import React from "react";
import ReactDOM from "react-dom";

const ModalWrapper = ({ className = "", children }) => {
  return ReactDOM.createPortal(
    <React.Fragment>
      <div

        className={`timer-popup-container modal fade text-center upi-popup-portal ${className}`}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        {children}
      </div>
    </React.Fragment>,
    document.getElementById("popUpRoot")
  );
};

export default ModalWrapper;
